import axios from "axios";
import { plainToInstance } from "class-transformer";
import { FeaturesDto } from "healthex-common/features.dtos";
import { apiConfig } from "./BaseApiService";
export class FeatureService {
    constructor(environment) {
        this.environment = environment;
    }
    async getGlobalFeatures() {
        var _a;
        const response = await axios.get(`${this.environment.API_BASE_URL}/features/global`, apiConfig());
        const featuresDto = response.data ? plainToInstance(FeaturesDto, response.data) : null;
        return (_a = featuresDto === null || featuresDto === void 0 ? void 0 : featuresDto.features) !== null && _a !== void 0 ? _a : [];
    }
    async getFeaturesForOrganization(organizationId) {
        var _a;
        const response = await axios.get(`${this.environment.API_BASE_URL}/organizations/${organizationId}/features`, apiConfig());
        const featuresDto = response.data ? plainToInstance(FeaturesDto, response.data) : null;
        return (_a = featuresDto === null || featuresDto === void 0 ? void 0 : featuresDto.features) !== null && _a !== void 0 ? _a : [];
    }
}
